import { useState, useEffect } from "react";
import api from "../lib/api";

export function useAllUsers(page = 1, perPage = 10, search = "") {
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await api.get(`/company/all-users`, {
                params: {
                    page,
                    per_page: perPage,
                    search: search || undefined
                },
            });

            if (response.data.success) {
                setData(response.data.data);
                setPagination(response.data.pagination);
            }
        } catch (err) {
            setError(err.response?.data?.message || "Failed to fetch users");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [page, perPage, search]);

    return { data, pagination, loading, error, refetch: fetchData };
}
